import flatten from 'flat';

import type { Utilities } from 'core';

import { rawBrandDesignTokens } from './brands';
import type { CSSProperties } from './css-in-js';
import type { DesignTokens } from './brands';

/**
 * Helper to return first key and second key of a property of the design system.
 */
export function extractKeysRegex(property: string) {
  const [, firstKey, secondKey] = new RegExp(/--(\w+)-(.+)/, 'g').exec(property) || [];

  return { firstKey, secondKey };
}

export const flattedDesignTokens: Utilities.PlainObject = flatten(rawBrandDesignTokens);

/**
 * converts a given word to <custom-property-name>
 */
function keyToCSSPropertyName(key: string): string {
  return `--${key.replace(/\./g, '-')}`;
}

/**
 * wraps a given word to <declaration-value>
 */
function valueToCSSVarDeclaration(value: string): string {
  return `var(${value})`;
}

/**
 * Creates a list of css variable declarations
 */
export function createRootCSSVariables(dsTokens: Record<string, string | number>) {
  return Object.entries(dsTokens).reduce((cssTheme, [key, value]) => {
    const cssCustomProperty = keyToCSSPropertyName(key);

    return {
      ...cssTheme,
      [cssCustomProperty]: value,
    };
  }, {});
}

/**
 * Creates the design tokens object with css variables
 */
export function createCSSTokensObject(tokenList: CSSProperties) {
  return Object.entries(tokenList).reduce((obj: Utilities.PlainObject, [property]) => {
    const cssVariableDeclaration: string = valueToCSSVarDeclaration(property);
    const { firstKey, secondKey } = extractKeysRegex(property);

    obj[firstKey] = { ...obj[firstKey] };
    obj[firstKey][secondKey] = cssVariableDeclaration;

    return obj;
  }, {}) as DesignTokens;
}

export const rootCssVariables = createRootCSSVariables(flattedDesignTokens);
export const designTokens = createCSSTokensObject(rootCssVariables);
